import {showErrorMessage} from '@/helper';

export default {

    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(() => reject([]));
        });
    },

    /** Vyhledá poradce pro BO autocomplete. */
    searchAdvisors(search) {
        return new Promise((resolve, reject) => {
            http.get('api/service-requirements/search-advisors', { params: { search } }).then(response => {
                resolve(response.data);
            }).catch(() => reject([]));
        });
    },

    /** Vrací klienty daného poradce filtrované volitelným hledaným řetězcem. */
    searchAdvisorClients(advisorId, search) {
        return new Promise((resolve, reject) => {
            http.get(`api/service-requirements/search-advisor-clients/${advisorId}`, { params: { search } }).then(response => {
                resolve(response.data);
            }).catch(() => reject([]));
        });
    },

    /** Vytvoří servisní požadavek z BO na poradce (multipart kvůli přílohám). */
    boCreate(data) {
        const formData = new FormData();
        formData.append('advisor_id', data.advisor_id);
        if (data.client_id != null) formData.append('client_id', data.client_id);
        formData.append('text', data.text);
        (data.attachments ?? []).forEach(file => formData.append('attachments[]', file));

        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/bo-create', formData, {
                headers: {'Content-Type': 'multipart/form-data'},
            }).then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    /** Vrací souhrnné počty pro BO dashboard: { total, unassigned, open }. */
    getStats() {
        return new Promise((resolve, reject) => {
            http.get('api/service-requirements/stats').then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    getServiceRequirements() {
        return new Promise((resolve, reject) => {
            http.get('api/service-requirements').then(response => {
                resolve(response.data);
            }).catch(() => reject([]));
        });
    },

    /** Vrací vlastní požadavky klienta rozdělené na { unresolved, resolved }. */
    getMyRequirements() {
        return new Promise((resolve, reject) => {
            http.get('api/service-requirements/my').then(response => {
                resolve(response.data);
            }).catch(() => reject({unresolved: [], resolved: []}));
        });
    },

    /**
     * Vrací požadavky poradce rozdělené na { unresolved, resolved }.
     * Zahrnuje přímé požadavky na poradce (bez klienta) i požadavky jeho klientů.
     */
    getMyAdvisorRequirements() {
        return new Promise((resolve, reject) => {
            http.get('api/service-requirements/my-advisor').then(response => {
                resolve(response.data);
            }).catch(() => reject({unresolved: [], resolved: []}));
        });
    },

    getServiceRequirement(id) {
        return new Promise((resolve, reject) => {
            http.get('api/service-requirements/' + id).then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    processServiceRequirement(id) {
        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/' + id + '/process').then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    resolveServiceRequirement(id) {
        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/' + id + '/resolve').then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    reopenServiceRequirement(id) {
        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/' + id + '/reopen').then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    updateStatus(id, status) {
        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/' + id + '/status', {status}).then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    getComments(id) {
        return new Promise((resolve, reject) => {
            http.get('api/service-requirements/' + id + '/comments').then(response => {
                resolve(response.data);
            }).catch(() => reject([]));
        });
    },

    /** Přiřadí přihlášeného BO uživatele jako řešitele — nastaví resolved_by na přihlášeného. */
    assignSelf(id) {
        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/' + id + '/assign').then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    /** Odebere přiřazeného řešitele — vymaže resolved_by. */
    unassignSelf(id) {
        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/' + id + '/unassign').then(response => {
                resolve(response.data);
            }).catch(() => reject(null));
        });
    },

    addComment(id, formData) {
        return new Promise((resolve, reject) => {
            http.post('api/service-requirements/' + id + '/comments', formData, {
                headers: {'Content-Type': 'multipart/form-data'},
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject(null);
            });
        });
    },
}
